import { AuthApis } from "../apis/AuthApis";

export const AuthServices = {
  fetchProfile: async () => {
    const response = await AuthApis.fetchProfile();
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }

    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  fetchAccountStatus: async () => {
    const response = await AuthApis.fetchAccountStatus();
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }
    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  saveAddress: async (address) => {
    const response = await AuthApis.saveAddress(address);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }
    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  emailSupport: async (emailSupportForm) => {
    const response = await AuthApis.emailSupport(emailSupportForm);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }
    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  loginUser: async (formData) => {
    const response = await AuthApis.loginUser(formData);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }

    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  createSecurePassword: async (p) => {
    const response = await AuthApis.createSecurePassword(p);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }
    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  passwordReset: async (formData) => {
    const response = await AuthApis.passwordReset(formData);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }
    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  createAccount: async (formData) => {
    const response = await AuthApis.createAccount(formData);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }

    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  createSubscription: async (tier) => {
    const response = await AuthApis.createSubscription(tier);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }

    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  verifySubscriptionSession: async (sessionId) => {
    const response = await AuthApis.verifySubscriptionSession(sessionId);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }

    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  verifyEmailToken: async (token, email, type) => {
    const response = await AuthApis.verifyEmailToken(token, email, type);
    if (!response.success) {
      return {
        success: false,
        status: 400,
        data: null,
        message: response,
      };
    }

    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  updateStoreOperations: async (data) => {
    const response = await AuthApis.updateStoreOperations(data);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }

    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  updateApplicationNumber: async (applicationNumber) => {
    const response = await AuthApis.updateApplicationNumber(applicationNumber);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }

    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  updateStripeAccount: async () => {
    const response = await AuthApis.updateStripeAccount();
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }
    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  updateDeliveryInstructions: async (formData) => {
    const response = await AuthApis.updateDeliveryInstructions(formData);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }

    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  updateID: async (formData) => {
    const response = await AuthApis.updateID(formData);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }

    return {
      status: response.status,

      success: true,
      data: response.data,
    };
  },

  updateAddress: async (formData, token) => {
    const response = await AuthApis.updateAddress(formData, token);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }

    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  updateOnboardingStatus: async (data) => {
    const response = await AuthApis.updateOnboardingStatus(data);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }

    return {
      status: response.status,
      success: true,
      message: response.message,
      data: response.data,
    };
  },

  updateApprovalStatus: async (approval) => {
    const response = await AuthApis.updateApprovalStatus(approval);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }

    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  updatePassword: async (password, token) => {
    const response = await AuthApis.updatePassword(password, token);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }

    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  passwordVerification: async (token) => {
    const response = await AuthApis.passwordVerification(token);
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }

    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },

  clearToken: async () => {
    const response = await AuthApis.clearToken();
    if (!response.success) {
      return {
        success: false,
        data: response.data,
        status: response.status,
        message: response.message,
      };
    }

    return {
      status: response.status,
      success: true,
      data: response.data,
      message: response.message,
    };
  },
};
